"use client"

const _cache = new Map<string, unknown>()

function get<T>(key: string, fallback?: T | undefined): T | undefined {
  if (!_cache.has(key)) return fallback

  return _cache.get(key) as T
}

function set<T>(key: string, value: T) {
  _cache.set(key, value)
}

function invalidate(key: string) {
  _cache.delete(key)
}

export const memoryCache = {
  get,
  set,
  invalidate,
}
